<template>
    <!-- 고정 container 끝 ---->
<div class="fixed-container" ref="fixedContainer">
  <cHeader></cHeader>
  <div class="sub-container">
    
      <div class="sub-title">
        <div class="title-wrap">
          <p class="t2">
            <!-- <span class="t-country">베트남</span>
          <span class="t-place">{{ classInfo?.title }}</span> -->
            <span class="t-country">{{ classInfo?.title }}</span>
          </p>
          <p class="t1">{{ examInfo?.oprNm }}</p>
          <!-- <p class="navi">{{ t('manager') }}</p> -->
          <p class="navi">{{ t('dateing') }}: {{ dateUtil.examDateFormat(examInfo.examDateTimeSt,
            examInfo.examDateTimeEnd)
            }}</p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-btn">
          <cBtn :thema="'dark-yellow'" :btnText="t('view_QR')" :btnSize="16" :customDesign="{ fontWeight: 'bold' }"
            @onClicked="openQr()"></cBtn>
        </div>
      </div>
      <div class="stat">
        <span>
          <span class="gubun">{{ t('all') }}</span>
          <span class="b">{{ totStat }}</span>
        </span>
        <span>
          <span class="gubun">{{ t('attended') }}</span>
          <span class="b">{{ statInfo.join }}</span>
        </span>
        <span>
          <span class="gubun">{{ t('absent') }}</span>
          <span class="br">{{ statInfo.disjoin }}</span>
        </span>
        <span>
          <span class="gubun">{{ t('upload_complete') }}</span>
          <span class="b">{{ statInfo.submit }}</span>
        </span>
        <span>
          <span class="gubun">{{ t('upload_incomplete') }}</span>
          <span class="br">{{ statInfo.notsubmit }}</span>
        </span>
      </div>
      <div class="list-top">
        <div class="search-gubun">
          <span class="chkbox" @click="chkboxSelected('all')">
            <img :src="searchGubun.all ? require('@/assets/checkbox_on.png') : require('@/assets/checkbox_off.png')">
            <span class="chkbox-nm">{{ t('all') }}</span>
          </span>
          <span class="chkbox" @click="chkboxSelected('join')">
            <img :src="searchGubun.join ? require('@/assets/checkbox_on.png') : require('@/assets/checkbox_off.png')">
            <span class="chkbox-nm">{{ t('attended') }}</span>
          </span>
          <span class="chkbox" @click="chkboxSelected('disjoin')">
            <img
              :src="searchGubun.disjoin ? require('@/assets/checkbox_on.png') : require('@/assets/checkbox_off.png')">
            <span class="chkbox-nm">{{ t('absent') }}</span>
          </span>
          <span class="chkbox" @click="chkboxSelected('submit')">
            <img :src="searchGubun.submit ? require('@/assets/checkbox_on.png') : require('@/assets/checkbox_off.png')">
            <span class="chkbox-nm">{{ t('upload_complete') }}</span>
          </span>
          <span class="chkbox" @click="chkboxSelected('notsubmit')">
            <img
              :src="searchGubun.notsubmit ? require('@/assets/checkbox_on.png') : require('@/assets/checkbox_off.png')">
            <span class="chkbox-nm">{{ t('upload_incomplete') }}</span>
          </span>
        </div>
        <div class="search-keyword">
          <input v-model="searchKeyWord" type="text" maxlength="20" :placeholder="t('examNumber_search')"
            @keydown.enter="goSearch()">
          <img :src="require('@/assets/ico-search_24_24.png')" @click="goSearch()">
        </div>
        <v-spacer></v-spacer>
        <div class="list-change">
          <img class="mr-2"
            :src="require(listType === 'card' ? '@/assets/icon-table-card-bg-on.png' : '@/assets/icon-table-card-bg.png')"
            @click="listType = 'card'">
          <img
            :src="require(listType === 'list' ? '@/assets/icon-table-list-bg-on.png' : '@/assets/icon-table-list-bg.png')"
            @click="listType = 'list'">
        </div>
      </div>
    </div>
    
  </div>
  <!-- 고정 container 끝 ---->
    <div class="scroll-container" :style="{padding:`${fixedContainerHeight}px 40px 40px 40px`}">
      <cTableCard v-if="listType === 'card'" :aplysList="showAplysList"></cTableCard>
      <cTableList v-if="listType === 'list'" :aplysList="showAplysList"></cTableList>
    </div>
    <pQr :isShow="isQr" @onClicked="printQr"></pQr>


</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount  } from 'vue'
import { useI18n } from 'vue-i18n';
import { useBaseStore } from '@/stores/base'
import { usePopupStore } from '@/stores/popup'
import { dateUtil, strUtil } from '@/utils';
import cHeader from '@/components/cHeader.vue';
import cTableList from '@/components/cTableList.vue';
import cTableCard from '@/components/cTableCard.vue';
import cBtn from '@/components/cBtn.vue'
import pQr from '@/popup/pQr.vue'


const baseStore = useBaseStore()
const popupStore = usePopupStore()
const { t, locale } = useI18n();

const listType = ref('card')
// const pageNum = ref(1)
const isQr = ref(false)

const openQr = () => {
  isQr.value = true;
}

const printQr = () => {
  isQr.value = false;
}

//================
const searchGubun = ref({ all: false, join: false, disjoin: false, submit: false, notsubmit: false })
const searchKeyWord = ref("")
const searchGubunAll = computed(() => {
  const keys = Object.keys(searchGubun.value);
  for (let i = 0; i < keys.length; i++) {
    if (keys[i] != 'all' && searchGubun.value[keys[i]] === false) {
      return false
    }
  }
  return true
})

const chkboxSelected = (key) => {
  if (key === 'all') {
    const tempVal = searchGubun.value[key]
    Object.keys(searchGubun.value).forEach(key => {
      searchGubun.value[key] = !tempVal;
    })
  } else {
    searchGubun.value[key] = !searchGubun.value[key]
    searchGubun.value['all'] = searchGubunAll.value
  }
}

const goSearch = async () => {
  await getOsessApplys()
}

const examInfo = ref({})
const classInfo = ref({})
const aplysList = ref([])
const showAplysList = ref([])
const statInfo = ref({ join: 0, disjoin: 0, submit: 0, notsubmit: 0 })
const totStat = computed(() => {
  return aplysList.value?.length || 0
})

onMounted(async () => {
  if (strUtil.isEmpty(baseStore.getManagerCd)) {
    popupStore.openDialog({ title: '', msg: "잘못된 접근입니다." });
    baseStore.goLogout()
  }

  examInfo.value = baseStore.getManagerInfo
  await getOsessApplys()
})

const getOsessApplys = async () => {
  const managerCd = baseStore.getManagerCd
  const { default: ApiGetOsessApplys } = await import('@/api/getOsessApplys');
  const params = { loginCode: managerCd }
  const getOsessApplys = await ApiGetOsessApplys(params)

  classInfo.value = getOsessApplys.classInfo
  aplysList.value = getOsessApplys.aplysList

  // console.log("시행관리자 정보: ", JSON.stringify(baseStore.getManagerInfo))
  // console.log("QR 정보: ", JSON.stringify(baseStore.getQrInfo))
  // console.log("교실정보: ", JSON.stringify(getOsessApplys.classInfo))
  // console.log("수험생정보: ",JSON.stringify(getOsessApplys.aplysList))

  showAplysList.value = await createShowAplysList()
}

const createShowAplysList = async () => {
  try {
    let tempShowList = []
    let joinCnt = 0
    let disjoinCnt = 0
    let submitCnt = 0
    let notsubmitCnt = 0

    for (const item of aplysList.value) {
      if (!(searchGubun.value.join === searchGubun.value.disjoin)) {
        const resultGubun = (searchGubun.value.join === true && item.examAttendYn !== 'Y') ||
          (searchGubun.value.disjoin === true && item.examAttendYn === 'Y')
          ? true : false
        if (resultGubun) {
          continue
        }
      }

      if (!(searchGubun.value.submit === searchGubun.value.notsubmit)) {
        const resultGubun = (searchGubun.value.submit === true && item.answerUploadYn !== 'Y') ||
          (searchGubun.value.notsubmit === true && item.answerUploadYn === 'Y')
          ? true : false

        if (resultGubun) {
          continue
        }
      }

      // 키워드 검색
      const keyword = searchKeyWord.value.toLowerCase().replace(/\s+/g, '');
      const iskeyword = !strUtil.isEmpty(keyword)
      if (iskeyword) {
        const name = (item.userLastNm + ' ' + item.userFirstNm).toLowerCase().replace(/\s+/g, '');
        const num = item.applyExamNo.replace(/\s+/g, '');
        const keywordResult = (name.includes(keyword) || num.includes(keyword)) ? true : false
        if (!keywordResult) {
          continue
        }
      }

      tempShowList.push({
        num: item.applyExamNo,
        name: item.userLastNm + ' ' + item.userFirstNm,
        quizDownYn: item.quizDownYn,
        examAttendYn: item.examAttendYn,
        answerUploadYn: item.answerUploadYn
      })

      if (item.examAttendYn === 'Y') {
        joinCnt++
      } else {
        disjoinCnt++
      }

      if (item.answerUploadYn === 'Y') {
        submitCnt++
      } else {
        notsubmitCnt++
      }
    }
    statInfo.value = { join: joinCnt, disjoin: disjoinCnt, submit: submitCnt, notsubmit: notsubmitCnt }
    return tempShowList
  } catch (error) {
    console.log('리스트 에러')
  }
}

// scroll-container top-padding  사이즈 ==============================================

const fixedContainerHeight = ref(0);
const fixedContainer = ref(null);
let observer = null;

const updateHeight = (entries) => {
  for (let entry of entries) {
    fixedContainerHeight.value = entry.contentRect.height;
    console.log("높이", fixedContainerHeight.value)
  }
};

onMounted(() => {
  if (fixedContainer.value) {
    observer = new ResizeObserver(updateHeight);
    observer.observe(fixedContainer.value);
  }
});

onBeforeUnmount(() => {
  if (observer && fixedContainer.value) {
    observer.unobserve(fixedContainer.value);
    observer.disconnect();
  }
});


// 자동 리로드 10초 마다 =======================================================================================
let reloadInterval;
onMounted(() => {
  let cnt = 0
  reloadInterval = setInterval( async () => {
    await getOsessApplys()
  }, 10000);
});

onBeforeUnmount(() => {
  clearInterval(reloadInterval);
});
</script>

<style lang="scss" scoped>
@import '@/sass/app.scss';


.fixed-container{
  position: fixed;
  width: 100%;
  height: auto;
  top: 0px;
  left: 0px;
  background-color: #fff;
}

.sub-container {
  width: 100%;
  height: 100%;
  padding: 0px 40px;
  position: relative;
}

.scroll-container {
  width: 100%;
  height: 100%;
}

.sub-title {
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 24px;

  p.navi {
    font-size: 18px;
    letter-spacing: -0.4px;
    line-height: 18px;
    font-family: 'Pretendard GOV';
    color: #666;
  }

  p.t1 {
    font-size: 32px;
    letter-spacing: -1.2px;
    line-height: 32px;
    font-family: 'Pretendard GOV';
    color: #111;
    margin-bottom: 20px;
    font-weight: bold;
  }

  p.t2 {
    margin-bottom: 24px;
  }

  span.t-country {
    display: inline-block;
    padding-top: 32px;
    padding-right: 8px;
    //border-right: solid 1px #e3e3e3;
    margin-right: 8px;
    font-size: 18px;
    letter-spacing: -0.4px;
    line-height: 18px;
    font-weight: bold;
    font-family: 'Pretendard GOV';
    color: #8d744a;
  }

  span.t-place {
    font-size: 18px;
    letter-spacing: -0.4px;
    line-height: 18px;
    font-weight: bold;
    font-family: 'Pretendard GOV';
    color: #111;
  }

  .d-btn {
    flex-shrink: 0;
  }

}

.stat {
  width: 100%;
  position: relative;
  border-radius: 8px;
  background-color: #f7f7f7;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  box-sizing: border-box;
  gap: 10px 40px;
  text-align: left;
  font-size: 18px;
  color: #111;
  font-family: 'Pretendard GOV';
  margin-bottom: 32px;

  @media screen and (max-width: 1024px) {
    font-size: 14px;
    gap: 10px 24px;
    padding: 32px 12px;
  }

  @media screen and (max-width: 1110px) {
    font-size: 16px;
    gap: 10px 24px;
    padding: 32px 12px;
  }

  span.gubun {
    padding-right: 8px;
    border-right: solid 1px #e3e3e3;
    margin-right: 8px;
    font-size: 20px;
    line-height: 20px;
  }

  span.b {
    font-weight: bold;
    font-size: 26px;
    line-height: 18px;
  }

  span.br {
    font-size: 26px;
    line-height: 18px;
    font-weight: bold;
    color: #f34831;
  }
}

.list-top {
  width: 100%;
  max-height: 72px;
  clear: both;
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  .search-gubun {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 18px;
    margin-right: 23px;
    flex-wrap: wrap;

    .chkbox {
      display: inline-flex;
      align-items: center;
      height: 16px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }

      span.chkbox-nm {
        font-size: 14px;
        color: #111;
        font-family: Pretendard;
      }
    }
  }

  .search-keyword {
    position: relative;
    width: 300px;
    margin-right: 30px;

    input[type=text] {
      width: 100%;
      height: 36px;
      border-radius: 12px;
      background-color: #fff;
      border: 1px solid #e3e3e3;
      box-sizing: border-box;
      padding: 7px 44px 7px 20px;
      text-align: left;
      font-size: 14px;
      color: #acacac;
      font-family: Pretendard;
    }

    img {
      position: absolute;
      top: 7px;
      right: 20px;
      width: 24px;
      height: 24px;
    }
  }

  .list-change {
    display: flex;
    width: 80px;

    img {
      width: 36px;
      height: 36px;
    }
  }

}

.list-page {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;

  div.on {
    width: 34px;
    height: 34px;
    text-align: center;
    border-radius: 50%;
    background-color: #333;
    padding: 10px 0;
    font-size: 14px;
    color: #fff;
    font-family: Pretendard;
  }

  div {
    width: 34px;
    height: 34px;
    text-align: center;
    padding: 10px 0;
    font-size: 14px;
    color: #8b8b8b;
    font-family: Pretendard;
  }
}
</style>